<template>
  <div class="el-container direction">
    <div class="item" v-if="$route.query && $route.query.type === 'file'">
      <fileUpload folder="files" v-model="val"></fileUpload>
      <div>上传文件地址： {{ val ? val : '...' }}</div>
    </div>
    <div class="item" v-if="$route.query && $route.query.type === 'lang'">
      <el-button :loading="update" @click="handleUpdate">手动更新语言包</el-button>
    </div>
  </div>
</template>
<script>
import fileUpload from '@/components/common/file-upload'
import { updateLanguageCDNPost } from '@/server/common'
export default {
  name: 'system-control',
  components: {
    fileUpload
  },
  data () {
    return {
      update: false,
      val: ''
    }
  },
  methods: {
    async handleUpdate () {
      this.update = true
      await updateLanguageCDNPost({})
      this.update = false
    }
  }
}
</script>
<style lang="scss" scoped>
.direction {
  flex-direction: column;
  .item {
    margin-top: 12px;
  }
}
</style>
